<template>
    <div class="call-config-numbers">
        <form class="mx-2 mx-xl-auto w-xl-50">
            <div v-for="phone in model.numbers" :key="phone.id" class="row phone-number">
                <div class="col-md-8 offset-md-2">
                    <label class="form-label fw-bold">
                        {{ formatPhone(phone.number) }}
                    </label>
                    <div class="row mb-2">
                        <div class="col-4 text-end">
                            <span class="form-control-plaintext">
                                Language
                            </span>
                        </div>
                        <div class="col-8">
                            <select class="form-control w-auto" v-model="phone.language">
                                <option v-for="lang in languages" :key="lang.value" :value="lang.value">{{ lang.text }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-4 text-end">
                            <span class="form-control-plaintext">
                                Voice
                            </span>
                        </div>
                        <div class="col-8">
                            <div class="input-group">
                                <select class="form-control" v-model="phone.voice" @input="voiceChanged">
                                    <option v-for="voice in voicesFor(phone.language)" :key="voice.value" :value="voice.value">{{ formatVoice(voice) }}</option>
                                </select>
                                <button class="btn btn-outline-primary" title="Play sample"
                                        :disabled="!phone.voice"
                                        @click.prevent="playSample(phone.voice)">
                                    <fa v-if="!playing" class="fa-play fa-fw"></fa>
                                    <fa v-if="playing" class="fa-pause fa-fw"></fa>
                                </button>
                            </div>
                            <div class="text-danger text-start" v-if="errors[phone.id]">
                                {{ errors[phone.id] }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div class="text-center my-5">
            <save-button label="Save Numbers"
                         @click.prevent="save"
                         :loading="loading"
                         :success="showSuccess"></save-button>
        </div>
    </div>
</template>
<script>
    import _ from 'lodash';
    import { Formatters } from '../../common/formatters';
    import { PickList } from '../../components/DataGrid/AutoForm';
    import SaveButton from '../../components/SaveButton';
    let audio = null;
    export default {
        emits: ['update'],
        props: ['callConfig', 'errors', 'loading'],
        components: {
            SaveButton
        },
        data: function () {
            return {
                model: {},
                playing: false,
                showSuccess: false,
            }
        },
        computed: {
            languages() {
                return PickList.languages;
            }
        },
        methods: {
            formatPhone(number) {
                return Formatters.phoneNumber(number);
            },
            formatVoice(voice) {
                let gender = voice.meta == 'F' ? 'Female' : 'Male';
                return `${voice.text} (${gender}, ${voice.lang})`;
            },
            playSample(voice) {
                const vm = this;
                if (vm.playing) {
                    audio?.pause();
                    return;
                }
                audio = new Audio(`https://files.fumbl.ai/public/audio/samples/${voice}.ogg`);
                audio.addEventListener('canplay', () => { audio.play(); });
                audio.addEventListener('playing', () => { vm.playing = true; });
                audio.addEventListener('pause', () => { vm.playing = false; });
                audio.addEventListener('ended', () => { vm.playing = false; });
            },
            save() {
                this.$emit('update', this.model);
            },
            success() {
                const vm = this;
                vm.showSuccess = true;
                setTimeout(() => {
                    vm.showSuccess = false;
                }, 5000);
            },
            voiceChanged() {
                audio?.pause();
            },
            voicesFor(language) {
                const langName = PickList.languages.find(l => l.value === language)?.text ?? '';
                let list = PickList.voices.filter(v => v.lang.includes(langName));
                return list.length ? list : PickList.voices;
            },
        },
        created() {
            this.model = _.cloneDeep(this.callConfig ?? {});
        },
        watch: {
            callConfig(value) {
                this.model = _.cloneDeep(value ?? {});
            }
        }
    }
</script>
